/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SVGIcons } from "cms/icons/svg-icons";
import { regular } from "cms/icons";

const {
    faEnvelope,
    faArrowUpRightFromSquare,
    faFile,
    faPlug
} = regular;

const ServiceListLinkDisplayComponent = (props) => {

    const {
        link,
        onChange,
        onRemove
    } = props || {};

    const {
        link_type,
        text,
        url
    } = link || {};

    const isMailTo = link_type === "mailto";
    const isIntegration = link_type === "integration";
    const isInternal = link_type === "internal";
    const isExternal = link_type === "external";

    const changeLink = () => {
        onChange(link);
    };
    const removeLink = () => {
        onRemove(link);
    };

    return (
        <Fragment>
            {link && (
                <div className='link-selector-display-container'>
                    <div
                        className='link-selector-display-panel'
                        onClick={changeLink}
                    >
                        <div className='link-selector-icon-container'>
                            <div>
                                {isInternal &&
                                    <FontAwesomeIcon icon={faFile}/>
                                }
                                {isExternal &&
                                    <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
                                }
                                {isMailTo &&
                                    <FontAwesomeIcon icon={faEnvelope}/>
                                }
                                {isIntegration &&
                                    <FontAwesomeIcon icon={faPlug}/>
                                }
                            </div>
                        </div>
                        <div className='link-selector-text-container'>
                            <div className='link-selector-text'>
                                {text}
                            </div>
                            <div className='link-selector-url'>
                                {url}
                            </div>
                        </div>
                    </div>

                    <div className='link-selector-buttons'>
                        <IconButton
                            size='small'
                            title={"Change"}
                            edge='end'
                            onClick={changeLink}
                        >
                            <SVGIcons.common.Edit style={{ cursor: "pointer" }}/>
                        </IconButton>
                        <IconButton
                            size='small'
                            title={"Remove"}
                            edge='end'
                            onClick={removeLink}
                        >
                            <SVGIcons.common.Delete style={{ cursor: "pointer" }}/>
                        </IconButton>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export { ServiceListLinkDisplayComponent as LinkDisplayComponent }; 